export { default } from './order-item.vue'
